import {FC, useEffect, useMemo, useState} from 'react'
import {Col, Form, Row} from 'react-bootstrap'
import {useTranslation} from 'react-i18next'
import ReactSelect from 'react-select'
import {getPlant2} from 'src/api/modules/getdatalist'
import {useAppDispatch, useAppSelector} from 'src/redux/hooks'
import {setSoItem, soSelector} from 'src/redux/slices/soSlices'

type TOption = {value: string; label: string}

interface Props {}

export const SelectPlant: FC<Props> = () => {
  const {t} = useTranslation()
  const dispatch = useAppDispatch()
  const {orderItem, detailSOContract, soItem} = useAppSelector(soSelector)

  const [options, setOptions] = useState<TOption[]>([])
  const [selected, setSelected] = useState<TOption | null>(null)

  const handleSelected = (option: TOption | null) => {
    setSelected(option)
    if (option) {
      const {value: plant, label: plant_desc} = option
      dispatch(setSoItem({...soItem, plant, plant_desc}))
    }
  }

  useEffect(() => {
    const handleFetchProductPlants = async () => {
      if (!orderItem) return
      if (!orderItem?.order_sub_detail) return
      if (!orderItem?.order_sub_detail?.sales_org_code) return

      const salesOrg = orderItem?.order_sub_detail?.sales_org_code ?? ''
      const distributionChannel = detailSOContract?.order_sub?.distribution_channel ?? ''
      const materialNumber = orderItem?.order_sub_detail.material_number ?? ''

      const res = await getPlant2(salesOrg, distributionChannel, materialNumber)
      setOptions(
        res.data.data.map((item: any) => {
          return {
            value: item.plant,
            label: `${item.plant}-${item.plant_name}`,
          }
        })
      )
    }

    handleFetchProductPlants()
  }, [])

  useEffect(() => {
    if (options.length === 0) return
    if (!orderItem) return
    const option = options?.find((item) => item.value === orderItem.plant) ?? null
    setSelected(option)
  }, [options, orderItem])

  return (
    <Row className='mb-3'>
      <Col md={4}>
        <Form.Label className='mt-3'>{t('Plant')}</Form.Label>
      </Col>
      <Col md={8}>
        <ReactSelect
          placeholder={t('pilih')}
          value={selected}
          options={options}
          onChange={(option: any) => handleSelected(option)}
        />
      </Col>
    </Row>
  )
}
